// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
// DayOfWeek comes from https://github.com/googleapis/googleapis/blob/master/google/type/dayofweek.proto
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["DAY_OF_WEEK_UNSPECIFIED"] = "DAY_OF_WEEK_UNSPECIFIED";
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
export var DayOfWeek_index;
(function (DayOfWeek_index) {
    DayOfWeek_index[DayOfWeek_index["DAY_OF_WEEK_UNSPECIFIED"] = 0] = "DAY_OF_WEEK_UNSPECIFIED";
    DayOfWeek_index[DayOfWeek_index["MONDAY"] = 1] = "MONDAY";
    DayOfWeek_index[DayOfWeek_index["TUESDAY"] = 2] = "TUESDAY";
    DayOfWeek_index[DayOfWeek_index["WEDNESDAY"] = 3] = "WEDNESDAY";
    DayOfWeek_index[DayOfWeek_index["THURSDAY"] = 4] = "THURSDAY";
    DayOfWeek_index[DayOfWeek_index["FRIDAY"] = 5] = "FRIDAY";
    DayOfWeek_index[DayOfWeek_index["SATURDAY"] = 6] = "SATURDAY";
    DayOfWeek_index[DayOfWeek_index["SUNDAY"] = 7] = "SUNDAY";
})(DayOfWeek_index || (DayOfWeek_index = {}));
// WeekOfMonth includes all possible references to weeks in the month, including both first/last, and first/second/third/fourth/fifth.
export var WeekOfMonth;
(function (WeekOfMonth) {
    WeekOfMonth["WEEK_OF_MONTH_UNSPECIFIED"] = "WEEK_OF_MONTH_UNSPECIFIED";
    WeekOfMonth["FIRST"] = "FIRST";
    WeekOfMonth["SECOND"] = "SECOND";
    WeekOfMonth["THIRD"] = "THIRD";
    WeekOfMonth["FOURTH"] = "FOURTH";
    WeekOfMonth["FIFTH"] = "FIFTH";
    WeekOfMonth["LAST"] = "LAST";
})(WeekOfMonth || (WeekOfMonth = {}));
export var WeekOfMonth_index;
(function (WeekOfMonth_index) {
    WeekOfMonth_index[WeekOfMonth_index["WEEK_OF_MONTH_UNSPECIFIED"] = 0] = "WEEK_OF_MONTH_UNSPECIFIED";
    WeekOfMonth_index[WeekOfMonth_index["FIRST"] = 1] = "FIRST";
    WeekOfMonth_index[WeekOfMonth_index["SECOND"] = 2] = "SECOND";
    WeekOfMonth_index[WeekOfMonth_index["THIRD"] = 3] = "THIRD";
    WeekOfMonth_index[WeekOfMonth_index["FOURTH"] = 4] = "FOURTH";
    WeekOfMonth_index[WeekOfMonth_index["FIFTH"] = 5] = "FIFTH";
    WeekOfMonth_index[WeekOfMonth_index["LAST"] = 6] = "LAST";
})(WeekOfMonth_index || (WeekOfMonth_index = {}));
// MonthOfYear stores the months in the year.
export var MonthOfYear;
(function (MonthOfYear) {
    MonthOfYear["MONTH_OF_YEAR_UNSPECIFIED"] = "MONTH_OF_YEAR_UNSPECIFIED";
    MonthOfYear["JANUARY"] = "JANUARY";
    MonthOfYear["FEBRUARY"] = "FEBRUARY";
    MonthOfYear["MARCH"] = "MARCH";
    MonthOfYear["APRIL"] = "APRIL";
    MonthOfYear["MAY"] = "MAY";
    MonthOfYear["JUNE"] = "JUNE";
    MonthOfYear["JULY"] = "JULY";
    MonthOfYear["AUGUST"] = "AUGUST";
    MonthOfYear["SEPTEMBER"] = "SEPTEMBER";
    MonthOfYear["OCTOBER"] = "OCTOBER";
    MonthOfYear["NOVEMBER"] = "NOVEMBER";
    MonthOfYear["DECEMBER"] = "DECEMBER";
})(MonthOfYear || (MonthOfYear = {}));
export var MonthOfYear_index;
(function (MonthOfYear_index) {
    MonthOfYear_index[MonthOfYear_index["MONTH_OF_YEAR_UNSPECIFIED"] = 0] = "MONTH_OF_YEAR_UNSPECIFIED";
    MonthOfYear_index[MonthOfYear_index["JANUARY"] = 1] = "JANUARY";
    MonthOfYear_index[MonthOfYear_index["FEBRUARY"] = 2] = "FEBRUARY";
    MonthOfYear_index[MonthOfYear_index["MARCH"] = 3] = "MARCH";
    MonthOfYear_index[MonthOfYear_index["APRIL"] = 4] = "APRIL";
    MonthOfYear_index[MonthOfYear_index["MAY"] = 5] = "MAY";
    MonthOfYear_index[MonthOfYear_index["JUNE"] = 6] = "JUNE";
    MonthOfYear_index[MonthOfYear_index["JULY"] = 7] = "JULY";
    MonthOfYear_index[MonthOfYear_index["AUGUST"] = 8] = "AUGUST";
    MonthOfYear_index[MonthOfYear_index["SEPTEMBER"] = 9] = "SEPTEMBER";
    MonthOfYear_index[MonthOfYear_index["OCTOBER"] = 10] = "OCTOBER";
    MonthOfYear_index[MonthOfYear_index["NOVEMBER"] = 11] = "NOVEMBER";
    MonthOfYear_index[MonthOfYear_index["DECEMBER"] = 12] = "DECEMBER";
})(MonthOfYear_index || (MonthOfYear_index = {}));
